/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { T as TolgeeT, useTranslate } from '@tolgee/react'

const useT = () => {
  const { t } = useTranslate()

  return { t, T: TolgeeT }
}

export default useT
